import { getKPIRequest } from "@/api/getKPIRequest.ts"
import type { KPIGroupRequest } from "@/types/kpiTypes.ts"

import type { MonthlyDisplayData } from "../../types/monthlyDisplayTypes.ts"

export const getMonthlyData = async (): Promise<MonthlyDisplayData> => {
  const req: KPIGroupRequest = {
    returnSize: 1,
    aggType: "Monthly",
    kpis: [
      { $type: "basic", id: 80, typeId: 1, aggFunction: "Sum", location: 2 },
      {
        $type: "basic",
        id: 80,
        typeId: 1,
        aggFunction: "Average",
        location: 2,
      },
      {
        $type: "calc",
        typeId: 1,
        expression: "[110]/24*100",
        name: "Plant Uptime",
        unit: "%",
        aggFunction: "Average",
        location: 2,
      },
    ],
  }

  const values = await getKPIRequest(req)

  return {
    gasToPipeline: values[0].values ? values[0].values[0].value : 0,
    averageGasToPipeline: values[1].values ? values[1].values[0].value : 0,
    averageUptime: values[2].values ? values[2].values[0].value : 0,
    remainingDowntime: 0,
  }
}
